import { GitHub } from '@mui/icons-material';
import { fetchGitIndicatorsData } from '../../../services/b2b-indicators-apiService';
import { fetchGitIotSamplingData } from '../../../services/b2b-iotsampling-apiService';
import { fetchGitLanguageData } from '../../../services/b2b-languages-apiService';
import { fetchGitPlansData } from '../../../services/b2b-plans-apiService';
import { fetchGitUserData } from '../../../services/b2b-users-apiService';
import CustomButton from '../../b2b-common/CustomButton';
import './MicroserviceCard.css';

import { Box, Typography, Divider } from '@mui/material';
import MicroserviceGitModal from '../forms/MicroserviceGitModal';
import { useState } from 'react';
import { fetchGitFrameworksData } from '../../../services/b2b-frameworks-apiService';
import { fetchGitReportingData } from '../../../services/b2b-reporting-apiServices';
import { fetchGitSocialData } from '../../../services/b2b-social-apiServices';
import { fetchGitLogbookData } from '../../../services/b2b-logbook-apiServices';

const GitMicroservices = [
    {
        microservice: "USERS",
        gitAPI: fetchGitUserData,
        fetchMethodParams: null,
    },
    {
        microservice: "PLANS",
        gitAPI: fetchGitPlansData,
        fetchMethodParams: null,
    },
    {
        microservice: "REPORTING",
        gitAPI: fetchGitReportingData,
        fetchMethodParams: null,
    },
    {
        microservice: "IOTSAMPLING",
        gitAPI: fetchGitIotSamplingData,
        fetchMethodParams: null,
    },
    {
        microservice: "LANGUAGES",
        gitAPI: fetchGitLanguageData,
        fetchMethodParams: null,
    },
    {
        microservice: "VERTICALFW",
        gitAPI: fetchGitFrameworksData,
        fetchMethodParams: "vertical",
    },
    {
        microservice: "INDICATORS",
        gitAPI: fetchGitIndicatorsData,
        fetchMethodParams: null,
    },
    {
        microservice: "SOCIAL",
        gitAPI: fetchGitSocialData,
        fetchMethodParams: null,
    },
    {
        microservice: "IOTFW",
        gitAPI: fetchGitFrameworksData,
        fetchMethodParams: "iot",
    },
    {
        microservice: "LOGBOOK",
        gitAPI: fetchGitLogbookData,
        fetchMethodParams: null,
    },
    {
        microservice: "GENERICFW",
        gitAPI: fetchGitFrameworksData,
        fetchMethodParams: "generic",
    },
]

const MicroserviceCard = ({ microservice }) => {
    const [openGitModal, setOpenGitModal] = useState(false);
    if (!microservice) return null;

    const {
        instanceId,
        hostName,
        app,
        ipAddr,
        status,
        port,
        securePort,
        actionType,
        lastUpdatedTimestamp,
        leaseInfo, // Added lease info
    } = microservice;

    const GitMicroservice = GitMicroservices.find(service => service.microservice === app) || null;

    // Format the timestamps to readable dates
    const formattedLastUpdated = new Date(Number(lastUpdatedTimestamp)).toLocaleString();
    const formattedRegistrationTimestamp = leaseInfo
        ? new Date(Number(leaseInfo.registrationTimestamp)).toLocaleString()
        : 'N/A';
    const formattedLastRenewalTimestamp = leaseInfo
        ? new Date(Number(leaseInfo.lastRenewalTimestamp)).toLocaleString()
        : 'N/A';

    return (
        <Box className="microservice-card" display="flex" flexDirection="column"
            gap={1} p={3} pb={5} borderRadius={2} boxShadow={2} backgroundColor="white"
            height={'100%'} boxSizing={'border-box'} width={'100%'} position={'relative'}
        >
            <Typography variant="h4" fontWeight="bold">{app}</Typography>
            <Typography variant="body2">Instance ID: {instanceId}</Typography>
            <Typography variant="body2">Host Name: {hostName}</Typography>
            <Typography variant="body2">IP Address: {ipAddr}</Typography>
            <Typography variant="body2">Status: {status}</Typography>
            <Typography variant="body2">Action Type: {actionType}</Typography>
            <Typography variant="body2">Port: {port.$} (Secure: {securePort.$})</Typography>
            <Divider />
            <Typography variant="body2">Last Updated: {formattedLastUpdated}</Typography>
            <Divider />
            <Typography variant="body2">Lease Info:</Typography>
            <Typography variant="body2">- Renewal Interval: {leaseInfo?.renewalIntervalInSecs || 'N/A'} seconds</Typography>
            <Typography variant="body2">- Duration: {leaseInfo?.durationInSecs || 'N/A'} seconds</Typography>
            <Typography variant="body2">- Registration Time: {formattedRegistrationTimestamp}</Typography>
            <Typography variant="body2">- Last Renewal Time: {formattedLastRenewalTimestamp}</Typography>
            <Box className="microservice-card-popups" display="flex" flexDirection="row" gap={1} mt={2}
                position={'absolute'} bottom={0} right={0} p={1}
            >
                {GitMicroservice && (
                    <CustomButton
                        icon={<GitHub />}
                        variant="outlined"
                        color="primary"
                        size="small"
                        className={'more-button'}
                        onClick={() => {
                            setOpenGitModal(true);
                        }}
                    />
                )}
            </Box>
            <MicroserviceGitModal
                microservice={GitMicroservice}
                open={openGitModal} 
                onCancel={() => { 
                    setOpenGitModal(false);
                }} 
            />
        </Box>
    );
}

export default MicroserviceCard;